<template>
  <div class="box3">
    <pageTitle
      title="C/C++是程序员的骄傲<br />编程语言的内功心法"
      text="现代编程语言的起点，长远IT职业发展首选<br />高薪企业的敲门砖！"
    />

    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="title">
              <p>{{ item.title }}</p>
              {{ item.p }}
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="content-box">
      <swiper :options="contentSwiper" ref="contentSwiper">
        <swiper-slide
          class="swiper-slides"
          v-for="i in list[cur].itemist"
          :key="i + Math.random()"
        >
          <div class="block2" :class="'slide' + (cur + 1)">
            <div class="box" v-show="cur != 0"></div>
            <swiper v-if="i.arr" :options="contentSwiper3">
              <swiper-slide v-for="j in i.arr" :key="j + Math.random()">
                <div class="imgbox">
                  <img :src="j.img" alt />
                </div>
              </swiper-slide>
            </swiper>

            <div class="imgbox" v-else>
              <img :src="i.img" alt />
            </div>
            <div
              v-show="i.arr"
              class="swiper-pagination-box3"
              :class="'pagination' + (cur + 1)"
            ></div>
            <p>{{ i.txt1 }}</p>
            <p>{{ i.txt2 }}</p>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-pagination-box2"
        v-show="list[cur].itemist.length != 1"
      ></div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    cSwiper() {
      return this.$refs.contentSwiper.swiper;
    },
  },
  data() {
    let that = this;
    return {
      activeIndex: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 10,
        // effect: "left",
        on: {
          slideChangeTransitionStart() {
            that.cur = this.realIndex;
          },
          click() {
            if (
              this.clickedIndex == 0 ||
              this.clickedIndex == 3 ||
              this.clickedIndex == 6
            ) {
              that.cur = 0;
            }
            if (
              this.clickedIndex == 1 ||
              this.clickedIndex == 4 ||
              this.clickedIndex == 7
            ) {
              that.cur = 1;
            }
            if (
              this.clickedIndex == 2 ||
              this.clickedIndex == 5 ||
              this.clickedIndex == 8
            ) {
              that.cur = 2;
            }
            if (this.clickedIndex == 0) {
              that.swiper.slidePrev();
            } else if (this.clickedIndex == 8) {
              that.swiper.slideNext();
            } else {
              that.swiper.slideTo(this.clickedIndex, 400, false);
            }
          },
        },
      },
      contentSwiper: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      contentSwiper3: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,

        spaceBetween: 50,
        autoplay: {
          delay: 3000, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },

        pagination: {
          el: ".swiper-pagination-box3",
        },
      },
      cur: 0,
      list: [
        {
          title: "灵活强大",
          p: "技术能力无上限",
          itemist: [
            {
              txt1: "C语言是延续50多年的经典编程语言，在计算机体系占据着不可取代的重要地位；C/C++能力上限非常高，在软件领域没有C++做不好和做不到的事情，只是开发者水平和成本问题。",
              txt2: "*数据来源于职友集，统计时间为2022年11月22日",
              arr: [
                {
                  img: require("../../../assets/coursePage/cPuls/box3/2.png"),
                },
                {
                  img: require("../../../assets/coursePage/cPuls/box3/1.png"),
                },
              ],
            },
          ],
        },
        {
          title: "人才稀缺",
          p: "各大名企高薪难求",
          itemist: [
            {
              txt1: "C/C++不好学，但是企业离不开(尤其是一线大厂)，这就导致了C/C++工程师的薪资居高不下，华为、腾讯、阿里等大厂急需C/C++人才，但高薪难求。",
              txt2: "*数据来源于: 看**网招聘数据",
              arr: [
                {
                  img: require("../../../assets/coursePage/cPuls/box3/4.png"),
                },
                {
                  img: require("../../../assets/coursePage/cPuls/box3/5.png"),
                },
              ],
            },
          ],
        },
        {
          title: "应用广泛",
          p: "职业类型选择多",
          itemist: [
            {
              txt1: "C/C++应用领域极其广泛，涉及基础软件、桌面系统、网络通信、音频视频、游戏娱乐等诸多领域，职业选择更多样！",
              txt2: "",
              img: require("../../../assets/coursePage/cPuls/box3/3.png"),
            },
          ],
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box3 {
  position: relative;
  padding: 80px 0px 48px;

  width: 100%;

  overflow: hidden;

  .swiper-box {
    position: relative;
    margin-top: 18px;
    margin-bottom: 20px;

    /deep/ .swiper-slide {
      width: 352px;

      .block {
        box-shadow: 0px 8px 29px 0px rgba(0, 129, 255, 0.25);
        transform: scale(0.9);
        transition: 0.5s all;
        margin-top: 30px;
        margin-bottom: 40px;
      }
    }

    .swiper-slide-active {
      .block {
        transform: scale(1);
        transition: 0.5s all;
        opacity: 1;
      }
    }

    .block {
      width: 352px;
      height: 153px;
      border: 5px solid #ffffff;
      background: linear-gradient(20deg, #f6f4fe 0%, #fbfbfe 100%);

      border-radius: 20px;

      text-align: center;
      opacity: 0.54;
      border-radius: 20px;
      box-sizing: border-box;

      .title {
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        color: #191c47;
        margin-top: 25px;

        p {
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #1d91ff;
          line-height: 42px;
          margin-bottom: 12px;
        }
      }
    }
  }

  .content-box {
    margin-top: -60px;
    position: relative;

    .swiper-slides {
      width: 690px;

      height: 804px;

      //height: 802px;
    }
  }
  .block2 {
    width: 686px;
    height: 720px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 8px 30px 0px #d9eefb;
    border: 2px solid #ffffff;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border-radius: 20px;
    overflow: hidden;
    margin-top: 40px;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    .box {
      height: 0px;
    }

    p:nth-child(4) {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 40px;
      padding: 0 12px;
    }
    p:nth-child(5) {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      margin-top: 16px;
    }
  }
  .slide1 {
    padding: 20px;
    box-sizing: border-box;
    .imgbox {
      width: 646px;
      height: 424px;
      background: #eff8fe;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 32px;
    }
    img {
      width: 596px;
      height: 360px;
    }
  }
  .slide2 {
    padding: 20px;
    box-sizing: border-box;
    box-sizing: border-box;
    .imgbox {
      width: 646px;
      height: 460px;
      background: #eff8fe;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      padding-top: 18px;
      margin-bottom: 36px;
      box-sizing: border-box;
    }
    img {
      width: 610px;
      height: 410px;
    }
    .swiper-pagination-box3 {
      top: 456px;
    }
  }
  .slide3 {
    padding: 20px;
    box-sizing: border-box;
    .imgbox {
      width: 646px;
      height: 514px;
      background: #eff8fe;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 34px;
    }
    img {
      width: 590px;
      height: 420px;
    }
  }
  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;
    margin-bottom: 30px;
    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 20px;
      height: 6px;
      background: #ffab9a;
      border-radius: 3px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      background: #ff5731;
      border-radius: 3px;
    }
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 6px;
    margin-bottom: 32px;
    border-radius: 3px;
    position: absolute;
    top: 422px;
    right: 36px;
    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 16px;
      height: 6px;
      background: rgba(208, 230, 244, 1);
      border-radius: 3px;
      margin-right: 4px;
      margin-left: 4px;
      opacity: 1;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 16px;
      height: 6px;
      background: rgba(78, 165, 255, 1);
      border-radius: 3px;
    }
  }
  .pagination2 {
    top: 438px;
  }
}
</style>
